function aplicarBordasPorMegamenu() {
  const megamenus = document.querySelectorAll('.gm-submenu');

  megamenus.forEach((submenu) => {
    const items = submenu.querySelectorAll('.gm-grid > li.gm-has-submenu');

    items.forEach(li => li.classList.remove('border-right'));

    items.forEach((li, i) => {
      if (i !== items.length - 1) {
        li.classList.add('border-right');
      }
    });
  });
}

setTimeout(() => {
  aplicarBordasPorMegamenu();
}, 500);
